import { useState } from "react";
import { useSearchParams } from "react-router";
import { useFetcher } from "../api.js";
import { useAuth } from "../auth.js";
import { Button, ErrorBox, useAction } from "../components/ui.js";
import { SignIn } from "./Home.js";

/** Approves a `repu login` device code. */
export function DevicePage() {
  const auth = useAuth();
  const fetcher = useFetcher();
  const [params] = useSearchParams();
  const [code, setCode] = useState(params.get("code") ?? "");
  const [result, setResult] = useState<string>();
  const decide = useAction(async (action: "approve" | "deny") => {
    const r = await fetcher<{ status: string; clientName: string }>(`/v1/auth/device/${action}`, { method: "POST", body: { userCode: code } });
    setResult(r.status === "approved" ? `Approved ${r.clientName}. You can return to your terminal.` : "Denied. The CLI will not be signed in.");
  });
  if (!auth.user) return <SignIn />;
  return (
    <div className="centered">
      <form
        className="panel form"
        onSubmit={(e) => {
          e.preventDefault();
          void decide.run("approve");
        }}
      >
        <h1>Sign in the repu CLI</h1>
        <p className="muted">
          Signed in as <strong>{auth.user.displayName ?? auth.user.email}</strong>. Only approve a code you requested yourself.
        </p>
        <label>
          Code from your terminal
          <input className="code-input" value={code} onChange={(e) => { setCode(e.target.value); }} placeholder="XXXX-XXXX" autoComplete="off" spellCheck={false} maxLength={9} required />
        </label>
        <ErrorBox error={decide.error} />
        {result ? (
          <p className="ok-text" role="status">
            {result}
          </p>
        ) : (
          <div className="form-actions">
            <Button type="button" busy={decide.busy} onClick={() => { void decide.run("deny"); }}>
              Deny
            </Button>
            <Button variant="primary" type="submit" busy={decide.busy}>
              Approve
            </Button>
          </div>
        )}
      </form>
    </div>
  );
}
